<template>
  <NetworkStatus v-if="isOffline"/>
  <div v-else>
    <div class="container-fluid hov py-4">
      <div v-if="cota" class="card-api mt-2 mb-6 px-3" style="border: 1px solid rgba(206, 85, 66, 0.5);border-radius: 5px;
          background: #111c44;">
        <div class="card-api-content d-flex justify-content-between">
          <div class="d-flex mt-2 pt-1">
            <div class="key pe-2 me-1">
              <i class="bi bi-exclamation-circle-fill fs-1 text-danger"></i>
            </div>
            <div class="text mx-3">
              <h6>{{ $t("messages.quota_reached") }}</h6>
              <p style="font-size: 13px">{{ $t("messages.quota_message") }}</p>
              <p style="font-size: 14px; margin-top: -10px">
                <a href="#" style="color: #4f61c4 !important" target="_blank">{{ $t("messages.change_plan") }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body d-flex">
          <form class="w-100" style="margin: 0 auto" @submit.prevent="sendMessage">
            <div class="row pt-0">
              <div class="mb-1">
                <div class="card-header px-0 d-flex mb-1">
                  <div class="form-check align-items-center">
                    <input id="message-group" v-model="activeTab" class="form-check-input" type="radio"
                           value="message-group"/>
                    <label class="form-check-label" for="message-group" style="transform: translateY(2px)">
                      {{ $t("messages.group_recipient") }}</label>
                  </div>
                  <div class="form-check ms-5">
                    <input id="other" v-model="activeTab" class="form-check-input" type="radio" value="other"/>
                    <label class="form-check-label" for="other"
                           style="transform: translateY(2px)">{{ $t("messages.individual_recipient") }}</label>
                  </div>
                </div>

                <div class="row">
                  <div v-if="activeTab === 'message-group'" class="col-md-10">
                    <div class="row pt-1 pb-2">
                      <div class="col-md-4">
                        <label>{{ $t("messages.select_level") }}</label>
                        <div class="dropdown">
                          <button class="btn dropdown-toggle text-light fw-bold ps-2 w-100" data-bs-toggle="dropdown"
                                  type="button">
                            {{ selectedGradeLabel }}
                          </button>
                          <ul class="dropdown-menu w-100 py-0">
                            <li class="dropdown-item" @click=" selectGrade('default', $t('messages.select'))">
                              {{ $t("messages.select") }}
                            </li>
                            <li class="dropdown-item" @click="selectGrade('all_grades', $t('messages.select_all'))">
                              {{ $t("messages.select_all") }}
                            </li>
                            <li v-for="grade in GRADE_CODE" :key="grade.id" class="dropdown-item"
                                @click="selectGrade(grade.code, grade.name)">
                              {{ grade.name }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div v-if="grade_class" class="col-md-4">
                        <label>{{ $t("messages.select_class") }}</label>
                        <div class="dropdown">
                          <button class="btn dropdown-toggle text-light fw-bold ps-2 w-100" data-bs-toggle="dropdown"
                                  type="button">
                            {{ selectedClassLabel }}
                          </button>
                          <ul class="dropdown-menu py-0 w-100">
                            <li class="dropdown-item" @click=" selectClass('all_classrooms', $t('messages.all_class'))">
                              {{ $t("messages.all_class") }}
                            </li>
                            <li
                                v-for="classroom in selectedGradeClassrooms"
                                :key="classroom.id"
                                class="dropdown-item"
                                @click="selectClass(classroom,$t('messages.class') + ' ' + classroom.number)">
                              {{ $t("messages.class") }} {{ classroom.number }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div v-if="showRecipientType" class="col-md-4">
                        <label>{{ $t("messages.recipient_type") }}</label>
                        <div class="dropdown">
                          <button
                              class="btn dropdown-toggle text-light fw-bold ps-2 w-100"
                              data-bs-toggle="dropdown"
                              type="button"
                          >
                            {{ selectedRecipientTypeLabel }}
                          </button>
                          <ul class="dropdown-menu py-0 w-100">
                            <li class="dropdown-item" @click="
                              selectRecipientType('', $t('messages.select')) "> {{ $t("messages.select") }}
                            </li>
                            <li v-if="admin_sdelect" class="dropdown-item"
                                @click="selectRecipientType('Admin', $t('messages.admins'))">
                              {{ $t("messages.admins") }}
                            </li>
                            <li
                                class="dropdown-item"
                                @click="selectRecipientType('Teachers', $t('messages.teachers'))">
                              {{ $t("messages.teachers") }}
                            </li>
                            <li v-if="parents" class="dropdown-item"
                                @click="selectRecipientType('Parents', $t('messages.parents'))">
                              {{ $t("messages.parents") }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="activeTab === 'other'" class="col-md-7">
                    <label>{{ $t("messages.phone") }}</label>
                    <p class="mt-n2 py-0 px-1" style="font-size: 12px; transform: translateY(7px)">
                      {{ $t("messages.matricul_text") }}
                    </p>

                    <div :class="{ required: errors.phones }" class="tag-input">
                      <div v-for="(tag, index) in tags" :key="index" :style="{
                          backgroundColor: tag.isValidEska === true ? '#27ae60' : tag.isValidEska === false ? '#e74c3c' : '#2980b9',
                          opacity: '1',
                          cursor: 'pointer',
                        }"
                           class="tag-input__tag"
                      >
                        <i class="bi bi-person-circle me-1"></i>
                        {{ tag.title || tag.number }}
                        <span
                            class="ms-2 text-white"
                            @click="tags.splice(index, 1)"
                        >
                          <i class="fa fa-close"></i>
                        </span>
                      </div>

                      <div class="d-flex align-items-center w-100">
                        <input v-model="searchQuery" :placeholder="$t('messages.enter_name')" autocomplete="off"
                            class="w-100"
                            style="width: 100%;border:none;outline:none;" type="text"
                            @input="handleSearch" @keydown="handleKeyDown"/>
                      </div>
                    </div>

                    <!-- Suggestions -->
                    <ul v-if="showSuggestions" class="list-group position-absolute custom-suggestion-list"
                        style="z-index: 20; width: 45%">
                      <li v-if="suggestions.length === 0" class="list-group-item text-center text-muted"
                          style="background: transparent; border: none">
                        {{ $t("messages.no_suggestion_found") }}
                      </li>
                      <li v-for="(suggestion, idx) in suggestions" :key="idx"
                          class="list-group-item list-group-item-action custom-suggestion-item"
                          style="cursor: pointer; display: flex; align-items: center;"
                          @click="addTag(suggestion)">
                        <img class="student-photo" v-if="suggestion.photo_url" :src="suggestion.photo_url" alt="photo"
                        />
                        <i v-else class="bi bi-person-circle me-2" style="font-size: 1.3em; color: #4f61c4"
                        ></i>
                        <div>
                          <span style="font-weight: 500">{{ suggestion.title }}</span>
                          <br/>
                          <small style="color: #888">{{ suggestion.subtitle }}</small>
                        </div>
                      </li>
                    </ul>
                    <small v-if="errors.phones" class="text-danger">{{ errors.phones}}</small>
                  </div>
                </div>
                <div v-if="eska" class="alert-matricule w-60 alert-warning mt-2 d-flex align-items-center justify-content-between"
                >
                  <div class="d-flex align-items-center">
                    <i class="bi bi-exclamation-triangle-fill me-2"></i>
                    <span class="text-light ms-2" style="font-size: 0.8rem">{{ $t("messages.invalid_matricule_warning") }}</span
                    >
                  </div>
                  <button
                      aria-label="Close"
                      class="btn-close ms-3 bg-danger"
                      style="font-size: 1.2rem"
                      type="button"
                      @click="eska = false"
                  >
                    <i class="text-white bi bi-x-lg"></i>
                  </button>
                </div>
              </div>

              <div class="row pe-0 mt-1">
                <div class="mb-1 col-8" v-if="tags.length || (level_selected && recipientType)">
                  <label style="color: grey">{{ $t("messages.message")}}<em style="color: #f60000">*</em></label>
                  <rich-text-editor
                      v-model="body"
                      @validationStatus="handleFrValidation"
                  >
                  </rich-text-editor>
                  <small v-if="errors.body" class="text-danger">{{ errors.body }}</small>
                </div>

                <div class="mb-1 d-none col-6" v-if="tags.length || selectedClass">
                  <label style="color: grey">{{ $t("messages.english_version") }}</label>
                  <rich-text-editor
                      v-model="body_en"
                      style="min-height: 200px;border: 1px solid rgba(250, 250, 250, 0.4);color: white;"
                      @validationStatus="handleEnValidation"
                  >
                  </rich-text-editor>
                  <small v-if="errors.body_en" class="text-danger">{{ errors.body_en }}</small>
                </div>
              </div>

              <div class="row" v-if="tags.length || (level_selected && recipientType)">
                <div class="col-6">
                  <div class="top">
                    <label for="media" style="color: grey; font-size: 12px">{{ $t("messages.add_media") }}</label><br/>
                    <input
                        id="media"
                        style="height: 42px; padding-top: 0; border: none;font-size: 13px"
                        type="file"
                        @change="handleFileUpload"
                    />
                  </div>
                  <div v-if="mediaFile" class="media-preview mt-3 ps-0">
                    <small>{{ $t("messages.added_file") }}:</small>
                    <div class="media-item">
                      <div class="media-info">
                        <img
                            v-if="isImage(mediaFile)"
                            :alt="$t('messages.file_preview')"
                            :src="mediaFile.preview"
                            class="img-thumbnail"
                        />
                        <span v-else>{{ mediaFile.name }}</span>
                      </div>
                      <button
                          id="btn-danger"
                          :title="$t('messages.delete_file')"
                          class="btn btn-danger"
                          @click="removeFile"
                      >
                        <i class="bi bi-x-lg"></i>
                      </button>
                    </div>
                  </div>
                  <div v-if="errorMessage" id="alert" class="alert ps-0 mt-3 d-flex justify-content-between align-items-center text-center">
                    <span>{{ errorMessage }}</span>
                    <button
                        aria-label="Close"
                        class="btn-close"
                        type="button"
                        @click="closeErrorMessage"
                    >
                      <i class="bi bi-x-lg"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="row mb-3 ps-2 text-start" v-if="tags.length || (level_selected && recipientType)">
                  <button id="send_message" v-if="!cota" :disabled="isLoading || isUploading" class="btn btn-success w-50" type="submit">
                    <span v-if="!isLoading && !isUploading">
                      <i aria-hidden="true" class="fs-5 fa fa-paper-plane text-light" style="margin-right: 6px"></i>
                      {{ $t("messages.send") }}
                    </span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin"></i>
                      <span v-if="isUploading">{{ $t("messages.uploading")}}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="list mb-10 mt-2">
          <ListMessage :campaigns="campaigns" :is-loading="isLoading"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RichTextEditor from "../components/TextEditor.vue";
import ListMessage from "./ListMessage.vue";
import {
  getAlertMessages,
  getCampaigns,
  getcheckmatriculEska,
  getGrades,
  getSpeciality,
  Search,
  sendmessage,
  uploadmedia,
} from "@/utils/services";
import {toast} from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import NetworkStatus from "@/views/components/NetworkStatus.vue";

export default {
  name: "Message_Vue",
  components: {RichTextEditor, ListMessage, NetworkStatus},
  data() {
    return {
      grade_code: "",
      level_selected: false,
      body_en: "",
      messages: [],
      cota: false,
      isValidFr: true,
      isValidEn: true,
      parents: true,
      recipientType: "",
      grade_class: false,
      eska: false,
      mediaFile: null,
      errorMessage: "",
      quota_day: false,
      activeTab: "message-group",
      activeIndex: null,
      quota_month: false,
      showRecipientType: true,
      recipientQuery: "",
      filteredStudents: [],
      GRADE_CODE: [],
      schoolList: [],
      selectedClassroom: "",
      isUploading: false,
      admin_sdelect: true,
      showEskaModal: false,
      fileURL: null,
      phoneNumbers: [],
      title: "",
      body: "",
      phone_list: [],
      badge: "",
      media: "",
      phoneList: [],
      currentPhone: "",
      tags: [],
      isLoading: false,
      selectedClassroomNumber: null,
      campaigns: [],
      isOffline: false,
      apiError: false,
      searchQuery: "",
      suggestions: [],
      showSuggestions: false,
      selectedClass: "all_classrooms",
      selectedGradeLabel: this.$t("messages.select"),
      selectedClassLabel: this.$t("messages.all_class"),
      selectedRecipientTypeLabel: this.$t("messages.select"),

      errors: {
        phones: "",
        title_fr: "",
        title_en: "",
        body_fr: "",
        body_en: "",
      },

      content: "",
      characterCount: 0,
      maxCharacters: 200,
    };
  },
  computed: {
    selectedGradeClassrooms() {
      const grade = this.GRADE_CODE.find((g) => g.code === this.grade_code);
      if (grade && grade.classrooms) {
        return grade.classrooms.map((classroom) => ({
          ...classroom,
        }));
      }
      return [];
    },
  },

  watch: {
    content(newContent) {
      this.characterCount = newContent.length;

      if (this.characterCount > this.maxCharacters) {
        this.content = newContent.slice(0, this.maxCharacters);
      }
    },
  },

  async mounted() {
    await this.updateOnlineStatus();
    await this.fetchGrades();
    await this.fetchCampaigns();

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.intervalId = setInterval(this.checkInternetConnection, 1000);

    if (!this.isOffline) {
      await this.fetchGrades();
    }
  },

  beforeUnmount() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },

  methods: {
    async addTag(suggestion) {
      const registration_number =
          suggestion.data && suggestion.data.student
              ? suggestion.data.student.registration_number
              : suggestion.registration_number;

      if (registration_number && !this.tags.some((tag) => tag.number === registration_number)) {
        let result = await getcheckmatriculEska(registration_number);
        let isValid = result && result.has_number_with_eska === true;

        this.tags.push({
          title: suggestion.title,
          number: registration_number,
          has_number_with_eska: result.has_number_with_eska,
          isValidEska: isValid,
          ...suggestion.data,
        });
        this.eska = !isValid;
      }
      this.searchQuery = "";
      this.showSuggestions = false;
    },
    selectGrade(code, label) {
      this.level_selected = true;
      this.grade_code = code;
      this.selectedGradeLabel = label;
      this.updateGradeCode({target: {value: code}});
    },
    selectClass(classroom, label) {
      this.selectedClass = classroom;
      this.selectedClassLabel = label;
      this.handleClassroomChange();
    },
    selectRecipientType(type, label) {
      this.recipientType = type;
      this.selectedRecipientTypeLabel = label;
    },

    handleKeyDown(event) {
      if (event.key === "Enter" || event.key === " " || event.key === "," || event.key === ";") {
        event.preventDefault();
        if (this.showSuggestions && this.suggestions.length > 0) {
          this.addTag(this.suggestions[0]);
        } else if (this.showSuggestions && this.suggestions.length === 0) {
          return;
        } else if (this.searchQuery.trim()) {
          this.addTagFromInput();
        }
      }
    },
    addTagFromInput() {
      const phone = this.searchQuery.trim();
      if (phone && !this.tags.some((tag) => tag.number === phone)) {
        this.tags.push({number: phone, title: phone});
      }
      this.searchQuery = "";
      this.suggestions = [];
      this.showSuggestions = false;
    },
    async handleSearch() {
      if (this.searchQuery.length >= 2) {
        try {
          const response = await Search(this.searchQuery);
          if (response.status === 200 && response.data && response.data.length > 0) {
            const filtered = response.data.filter((item) => item.classroom);
            this.suggestions = filtered.map((item) => ({
              title: `${item.student.first_name} ${item.student.last_name}`,
              subtitle: `${item.classroom.grade.name} ${item.classroom.speciality_code ? item.classroom.speciality_code : ""} - ${item.classroom.number}`,
              data: item,
              photo_url: item.student.photo_url || null,
            }));
          } else {
            this.suggestions = [];
          }
          this.showSuggestions = true;
        } catch (error) {
          console.error("Search error:", error);
          this.suggestions = [];
        }
      } else {
        this.suggestions = [];
        this.showSuggestions = false;
      }
    },

    async updateOnlineStatus() {
      if (navigator.onLine) {
        try {
          await this.checkConnection();
          this.isOffline = false;
        } catch (error) {
          console.error("Error checking connection:", error);
          this.isOffline = true;
        }
      } else {
        this.isOffline = true;
      }
    },

    async checkConnection() {
      try {
        await Promise.all([getGrades()]);
        this.apiError = false;
      } catch (error) {
        console.error("API Error:", error);
        this.apiError = true;
      }
    },

    async fetchCampaigns() {
      this.isLoading = true;
      try {
        const response = await getCampaigns();
        this.campaigns = [...response].reverse();
      } catch (error) {
        console.error("Error fetching campaigns:", error);
      } finally {
        this.isLoading = false;
      }
    },

    handleClassroomChange() {
      if (this.selectedClass) {
        this.selectedClassroomNumber = this.selectedClass.number;
      } else {
        this.selectedClassroomNumber = null;
      }
    },
    updateClassroom(event) {
      const selectedClassId = parseInt(event.target.value);
      const selectedClass = this.selectedGradeClassrooms.find(
          (classroom) => classroom.id === selectedClassId
      );

      if (selectedClass) {
        this.selectedClassroomNumber = selectedClass.number;
      }
    },

    updateGradeCode(event) {
      this.grade_code = event.target.value;
      //console.log("Grade code selected:", this.grade_code);

      if (this.grade_code === "all_grades") {
        this.showRecipientType = true;
        this.recipientType = "";
        this.grade_class = false;
        this.admin_sdelect = false;
      } else if (this.grade_code === "default") {
        this.showRecipientType = true;
        this.recipientType = "";
        this.grade_class = false;
        this.admin_sdelect = true;
        this.parents = false;
      } else if (
          this.grade_code !== "default" &&
          this.grade_code !== "all_grades"
      ) {
        this.showRecipientType = true;
        this.recipientType = "";
        this.grade_class = true;
        this.admin_sdelect = false;
      } else {
        this.showRecipientType = false;
        this.grade_class = true;
        this.admin_sdelect = true;
      }
    },

    async fetchGrades() {
      const response = await getGrades();
      if (response.status === 200) {
        this.GRADE_CODE = response.data;
      }
    },

    async fetchMessages() {
      try {
        this.messages = await getAlertMessages();
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    },
    handleFrValidation(isValid) {
      this.isValidFr = isValid;
    },

    handleEnValidation(isValid) {
      this.isValidEn = isValid;
    },

    updateCharacterCount() {
      this.characterCount = this.content.length;

      if (this.characterCount >= this.maxCharacters) {
        this.content = this.content.slice(0, this.maxCharacters);
        this.characterCount = this.maxCharacters;
      }
    },

    onEditorChangeFr(value) {
      // Update `body_fr` with la new value
      this.body_fr = value;
    },
    onEditorChangeEn(value) {
      // Update `body_en` with la new value
      this.body_en = value;
    },

    toggleDetails(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },

    async getData() {
      let grades = await getGrades();
      this.GRADE_CODE = grades.data;
      this.grade_code = grades.data[0].name;
      this.grade_name = grades.data[0].name;
      let specialities = await getSpeciality();
      this.SPECIALITY_CODE = specialities.data;

      if (specialities.data.length > 0 && specialities.data[0].short_name) {
        this.speciality = specialities.data[0].short_name;
      } else {
        this.speciality = null;
      }
    },

    async sendMessage() {
      this.errors = {phones: "", title: "", body: ""};
      let hasErrors = false;
      if (this.activeTab === "other" && this.tags.length === 0) {
        this.errors.phones = this.$t("messages.errors.phone_required");
        hasErrors = true;
      }
      if (!this.body) {
        this.errors.body = this.$t("messages.errors.message_required");
        hasErrors = true;
      }
      if (hasErrors) return;
      if (!this.isValidFr || !this.isValidEn) {
        alert(this.$t("messages.errors.character_limit"));
        return;
      }
      this.isLoading = true;
      try {
        if (this.activeTab === "message-group") {
          const messageData = {
            target: this.recipientType,
            grade: this.grade_code,
            classroom_number: this.selectedClass
                ? this.selectedClass.number
                : null,
            body: this.body,
            media_url: this.fileURL || "",
          };
          //console.log("Message Data:", messageData);

          await sendmessage(messageData);
          this.clearForm();
          toast.success(this.$t("messages.success.message_sent"), {
            autoClose: 3000,
          });
          setTimeout(() => {
            window.location.reload();
          }, 4000);
        } else {
          const messageData = {
            body: this.body,
            media_url: this.fileURL || "",
            registration_number_list: this.tags.map((tag) => tag.number),
          };

          await sendmessage(messageData);
          this.clearForm();
          toast.success(this.$t("messages.success.message_sent"), {
            autoClose: 3000,
          });
          setTimeout(() => {
            window.location.reload();
          }, 4000);
        }
      } catch (error) {
        console.error("Error while sending message :", error);
        this.errorMessage = this.$t("messages.errors.send_failed");
      } finally {
        this.isLoading = false;
      }
    },

    clearForm() {
      this.body = "";
      this.mediaFile = null;
      this.fileURL = null;
      this.phoneList = [];
      this.phone_list = [];
      this.tags = [];
      this.selectedClass = "all_classrooms";
      this.grade_code = "";
      this.recipientType = "";
      this.grade_class = false;
      this.admin_sdelect = true;
      this.errors = {
        phones: "",
        title_fr: "",
        title_en: "",
        body_fr: "",
        body_en: "",
        body: "",
      };
      this.searchQuery = "";
      this.suggestions = [];
      this.showSuggestions = false;
      this.selectedClassroomNumber = null;
      this.media = "";
      this.badge = "";
      this.currentPhone = "";
      this.activeTab = "message-group";
      this.eska = false;
      this.mediaFile = null;
      this.errorMessage = "";

      const fileInput = document.getElementById("media");
      if (fileInput) fileInput.value = "";
    },

    close() { this.eska = false;},

    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const isValidImage =
            file.type.match(/image\/(jpg|jpeg|gif|png)/) && file.size <= 5242880;
        const isValidVideo = file.type === "video/mp4" && file.size <= 5242880;

        if (isValidImage || isValidVideo) {
          this.isUploading = true; // Upload start
          const reader = new FileReader();
          reader.onload = async (e) => {
            file.preview = e.target.result;
            this.mediaFile = file;
            this.errorMessage = "";

            let res = await uploadmedia(this.mediaFile);
            this.fileURL = res.url;
            this.isUploading = false; // End upload
          };
          reader.readAsDataURL(file);
        } else {
          this.errorMessage =
              "Only images (jpg, jpeg, gif, png) and video (mp4) with max size 5 Mo are authorize.";
          this.removeFile();
        }
      }
    },

    removeFile() {
      this.mediaFile = null;
      document.getElementById("media").value = "";
    },
    isImage(file) {
      return file.type.startsWith("image/");
    },
    closeErrorMessage() {
      this.errorMessage = "";
    },

    filterStudents() {
      const query = this.recipientQuery.toLowerCase();
      if (query === "") {
        this.filteredStudents = [];
      } else {
        this.filteredStudents = this.students.filter((student) =>
            student.name.toLowerCase().includes(query)
        );
      }
    },
    selectStudent(student) {
      this.recipientQuery = `${student.name}\n${student.parentPhone} - ${student.class}`;
      this.filteredStudents = [];
      if (student.eska.toLowerCase() === "non") {
        this.eska = true;
      }
    },
  },
  beforeMount() {
    this.getData();
  },
};
</script>

<style scoped>
.tag-input {
  width: 100%;
  background: transparent;
  border: 1px solid rgba(250, 250, 250, 0.4);
  border-radius: 10px;
  font-size: 0.9em;
  min-height: 50px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-content: flex-start;
  position: relative;
}

.tag-input__tag {
  display: inline-flex;
  align-items: center;
  height: 30px;
  color: white;
  font-size: 14px;
  background-color: #2980b9;
  border-radius: 15px;
  padding: 0 8px;
  margin: 2px;
}


.tag-input.required {
  border: 2px solid #f13939 !important;
  animation: shake 0.5s;
}

input[type="text"],
input[type="file"],
select.form-select {
  background-color: transparent;
  border: 1px solid rgba(250, 250, 250, 0.4);
  color: white;
}

input[type="text"]:focus,
input[type="file"]:focus,
select.form-select:focus {
  outline: none;
  border-color: gray;
}

input[type="text"]::placeholder,
select.form-select option {
  color: rgba(255, 255, 255, 0.6);
  background: transparent;
}

.container-fluid {
  background-color: transparent;
}

.card {
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.card-header {
  margin-bottom: 30px;
}

.card-body {
  padding: 20px;
  display: flex;
  justify-content: space-between;
}

.media-preview {
  flex: 0 0 30%;
}

.media-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.media-info {
  display: flex;
  align-items: center;
}

.img-thumbnail {
  max-width: 50px;
  max-height: 50px;
  margin-right: 10px;
}

.btn-success:hover {
  background: transparent;
}

#icon i {
  cursor: pointer;
}

#send_message {
  height: 50px;
  margin-top: 30px;
  border: 1px solid #2dceb1;
}

#btn-danger {
  transform: translateY(10px);
  border-radius: 100%;
  height: 40px;
  width: 40px;
  position: relative;
  opacity: 0.8;
}

#btn-danger .bi {
  position: absolute;
  left: 13px;
  top: 10px;
  font-weight: bold;
}

.alert {
  max-width: 80%;
  margin: 0 auto;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  position: absolute;
  top: -10px;
  right: -10px;
  background: white;
  color: red;
  opacity: 1;
  border-radius: 50%;
}

#alert {
  background: rgba(0, 0, 0, 0.6);
  transform: translateX(-50px);
  padding: 10px;
  opacity: 0.4;
  border: 2px solid #ce5542;
  position: relative;
  color: #ce5542;
}

.alert-matricule {
  background: rgba(31, 31, 31, 0.3);
  padding: 10px;
  border: 1px solid #ce5542;
  position: relative;
}

.hov {
  position: relative;
}

#li {
  border: 1px solid rgba(250, 250, 250, 0.4);
  padding: 10px 15px;
  list-style: none;
}

#li:hover {
  background: rgba(0, 0, 0, 0.6);
}

#li .li {
  justify-content: space-between;
}

#close {
  cursor: pointer;
  transition: 0.3s;
}

#close:hover {
  color: #ce5542;
}

textarea {
  min-height: 38px;
  height: auto;
}

.phone-input-container {
  position: relative;
}

.phone-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.phone-tag {
  background-color: #75acff;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-tag i {
  cursor: pointer;
  font-size: 14px;
}

:deep(.quill-editor) {
  height: 200px !important;
}

.phone-tag i:hover {
  opacity: 0.8;
}

.tag-input {
  width: 100%;
  border: 1px solid #d9dfe7;
  background: transparent;
  border-radius: 10px;
  font-size: 0.9em;
  min-height: 45px;
  box-sizing: border-box;
  padding: 0 10px;
  margin-bottom: 10px;
}

.tag-input__tag {
  height: 24px;
  color: white;
  float: left;
  font-size: 14px;
  margin-right: 10px;
  background-color: #2980b9;
  border-radius: 15px;
  margin-top: 10px;
  line-height: 24px;
  padding: 0 8px;
}

.tag-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
  display: inline-block;
  margin-left: 8px;
}

.tag-input__text {
  border: none;
  outline: none;
  font-size: 1em;
  line-height: 40px;
  background: none;
}

.text-danger {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.tag-input__tag.invalid {
  background-color: #dc3545;
}

select.form-select option {
  background: black;
  color: white;
}

/* For the default empty option */
select.form-select option[value=""] {
  background: black;
  color: white;
}

.legend-container {
  display: flex;
  gap: 20px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.legend-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.tag-input {
  width: 100%;
  border: 1px solid rgba(250, 250, 250, 0.4);
  background: transparent;
  border-radius: 10px;
  font-size: 0.9em;
  min-height: 50px;
  height: auto !important;
  box-sizing: border-box;
  padding: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-content: flex-start;
}

.bi-check-circle-fill {
  font-size: 14px;
  color: white;
}

.bi-question-circle-fill {
  font-size: 14px;
  color: white;
}

.tag-input__text {
  flex: 1;
  min-width: 120px;
  height: 30px;
  border: none;
  outline: none;
  font-size: 1em;
  background: none;
  color: white;
  padding: 5px 0;
}

.tag-input__tag {
  display: inline-flex;
  align-items: center;
  height: 30px;
  color: white;
  font-size: 14px;
  background-color: #2980b9;
  border-radius: 15px;
  padding: 0 8px;
  margin: 2px;
}

input[type="text"] {
  background-color: transparent !important;
  color: white;
  border: 1px solid rgba(250, 250, 250, 0.4);
}

input[type="text"]:focus {
  background-color: transparent !important;
  color: white;
  box-shadow: none;
}

input[type="text"]::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.eska-tag-logo {
  width: 16px;
  height: 16px;
  object-fit: contain;
  vertical-align: middle;
  border-radius: 50%;
}

.custom-suggestion-list {
  background: #222c4a;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  margin-top: 2px;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #4f61c4;
}

.custom-suggestion-item {
  background: transparent;
  color: #fff;
  border: none;
  transition: background 0.2s;
}

.custom-suggestion-item:hover {
  background: #4f61c4;
  color: #fff;
}

.dropdown-toggle {
  width: 200px;
  color: white;
  background: #051139;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
}

.dropdown-menu {
  background: #111c44;
  color: white;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 0;
}

.dropdown-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(250, 250, 250, 0.1);
  transition: background-color 0.3s ease;
  color: white;
  height: 45px;
  padding-top: 12px;
}

.dropdown-item:hover {
  background: rgba(250, 250, 250, 0.1);
  color: black;
}

.student-photo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}
</style>
